import { LoadingOutlined } from '@ant-design/icons';

const Loader = () => (
  <LoadingOutlined style={{ fontSize: 14 }} spin />
);

export default Loader;
